angular.module("controllers").controller("descriptionUnitGeneralTechnicalEquipmentController", function ($scope, $q, $controller, project, itemDataService, ModalService, $state, projectService, descriptionUnit) {
	$controller("descriptionUnitBaseController", { $scope: $scope, project: project, itemDataService: itemDataService, descriptionUnit: descriptionUnit });

})
